import React, {useEffect, useMemo, useState} from "react";
import NoDataContent from "../../../../../../components/reports/report-menu/no-data-content.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import projectUtils from "../../../../../../utils/project-utils.js";

const reportId = "status-bo"
const BoStatus = ({data, boName}) => {
  const reportName = useMemo(() => `Status do ${boName}`, [boName]);


  useEffect(() => {
    data?.length &&  ReportUtils.createExportableTable(null, null, reportName, reportId);
  }, [data, reportName]);

  return(
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
      </div>
      {
        data.length > 0
        ?<div className="mt-3 mb-3">
            <table id={reportId} className="table report-table" sheet-name={reportName}>
              <thead className="thead-background print:table-row-group!">
              <tr className="bg-[#f6f6f6] text-left">
                <th className="w-[10%]">Quantidade</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              {data.map((el, index) => (
                <React.Fragment key={index}>
                  <tr className={`table-break-word`}>
                    <td className="w-[10%]">{el.qty}</td>
                    <td>{el.bo_status}</td>
                  </tr>
                </React.Fragment>
              ))}
              </tbody>
            </table>
         </div>
          : <div className="mt-1"><NoDataContent reportData={true} data={0}/></div>
      }
      <div className="chart-divisor"></div>
    </>
  )
}

export default BoStatus;